import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class I130Service {

  constructor(
    private http: HttpClient
  ) { }

  getUsersOfCompany(companyId) {
    return this.http.get('/company/' + companyId + '/employee').pipe(
      map((response: ImagilityBaseResponse) => response.data)
    );
  }

  getServiceCenters(isPremium) {
    return this.http.get(`/I130/serviceCenter/${isPremium}`).pipe(
      map((response: ImagilityBaseResponse) => response.data)
    );
  }

  getEmployeeDetails(companyId, employeeId) {
    return this.http.get(`/company/${companyId}/employee/${employeeId}`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getDependentsList(taskTypeCode, immClassificationCode, beneficiaryId) {
    return this.http.get(
      `/${taskTypeCode}/${immClassificationCode}/beneficiary/${beneficiaryId}/dependentDetails`)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response.status === 200) {
            return response.data;
          }
          return null;
        })
      );
  }

}
